<mat-expansion-panel class="" (opened)="panelOpened(showSelected)" (closed)="panelClosed(showSelected)">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title class="sx-filter__term__title" style="text-align: left;
      flex-grow: 1;
      line-height: 0;">
      <span class="sx-filter__term-header__title">{{filter.label}}</span>
      <span class="sx-filter__term-header__subtitle" *ngIf="showSelected">{{value}}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="sx-help-glossary__term__description">
      <div class="sx-multi-choice-filter__panel" (click)="$event.stopPropagation()">
          <div class="sx-multi-choice-filter__section">
            <div class="sx-multi-choice-filter__row">
              <ul class="sx-multi-choice-filter__row--ul">
                <li *ngFor="let s of selections" class="sx-multi-choice-filter__row--li">
                  <mat-checkbox [(ngModel)]="s.selected" (change)="updateFilter($event)">{{s.name}}</mat-checkbox>
                </li>
              </ul>
            </div>
          </div>
      </div>
  </div>
</mat-expansion-panel>